import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react';
import components from './components';
import global from './global';
import colors from './colors';

export const customizeTheme = ({ globalStyle, themeConfig }) => extendTheme(
  {
    styles: {
      global: {
        ...global,
        ...globalStyle,
      },
    },
    fonts: {
      heading: 'proxima-nova',
      body: 'proxima-nova',
    },
    ...themeConfig,
    colors,
    components,
  },
  withDefaultColorScheme({ colorScheme: 'primary' }),
);
